<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/storeSubscription/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</template>
			<template #actions><el-button plain v-if="btnPermission.audit" size="small" type="primary" icon="el-icon-s-check" @click="handleBatchAuditClick()">批量审核</el-button></template>
			<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="编号：">
					<el-input v-model="formInline.code" placeholder="请输入申购单编号" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="申请时间：">
					<el-date-picker
						v-model="dateRange"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy年MM月dd日"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="申购类型：">
					<el-select v-model="formInline.state" placeholder="请选择申购类型" clearable size="small" filterable>
						<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否支付：">
					<el-select v-model="formInline.isPay" placeholder="请选择是否支付" clearable size="small">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="已支付" :value="true"></el-option>
						<el-option label="未支付" :value="false"></el-option>
					</el-select>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId" height="560" @selection-change="handleSelectionChange">
				<template #code>
					<el-table-column label="申购单编号" min-width="220" align="center">
						<template #default="scope">
							<el-link type="primary" :underline="false" @click="handleDetailClick(scope.row)">
								{{ scope.row.code }}
							</el-link>
						</template>
					</el-table-column>
				</template>
				<template #stateStr>
					<el-table-column label="申购状态" min-width="120" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.state == 1" type="info">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 2" type="primary">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 8" type="danger">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 3" type="info">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 4" type="warning">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 5" type="warning">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 6" type="primary">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else type="success">{{ scope.row.stateStr }}</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column label="操作" min-width="220" align="center" fixed="right">
						<template #default="scope">
						<div class="lcsj-row-actions"><button class="lcsj-row-actions__link" v-if="btnPermission.purchaseConfirm && (scope.row.state == 2 || scope.row.state == 8)" @click="handlePurchaseConfirmClick(scope.row)">
							采购确认
							</button>
							<button class="lcsj-row-actions__link" v-if="btnPermission.audit && scope.row.state == 3" @click="handleAuditClick(scope.row)">审核</button>
							<button class="lcsj-row-actions__link" v-if="btnPermission.pay && (scope.row.state == 4 || scope.row.state == 6 || scope.row.state == 7) && !scope.row.payDate" @click="handlePayClick(scope.row)">
							支付
							</button>
							<button class="lcsj-row-actions__link" v-if="btnPermission.kuaidi && scope.row.state == 4" @click="handleKuaidiClick(scope.row)">发货</button>
						</div>
					</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 详情弹出框 -->
		<detail ref="detail"></detail>
		<!-- 采购确认弹出框 -->
		<purchaseConfirm ref="purchaseConfirm" :store-list="storeList"></purchaseConfirm>

		<!-- 审核是否通过 -->
		<lcsj-dialog v-model="auditVisible" title="审核是否通过" width="720px" cancel-text="取消" confirm-text="确认"
			 :close-on-click-modal="false"
			 :confirm-loading="isSubmitting" @confirm="handleAuditSubmit"> <span style="display: block; margin-bottom: 20px"><strong>审核结果:</strong></span>
			<el-radio-group v-model="auditResultInfo.isPass" style="margin-bottom: 20px">
				<el-radio :label="true">通过</el-radio>
				<el-radio :label="false">驳回</el-radio>
			</el-radio-group>
			<span v-if="!auditResultInfo.isPass" style="display: block; margin-bottom: 20px"><strong>驳回原因:</strong></span>
			<el-input v-if="!auditResultInfo.isPass" v-model="auditResultInfo.reason" placeholder="请输入驳回原因" type="textarea" rows="4" maxlength="200" show-word-limit></el-input></lcsj-dialog>
		<!-- 批量录入快递单号 -->
		<lcsj-dialog v-model="kuaidiVisible" title="录入快递单号" width="720px" cancel-text="取消" confirm-text="确认"
			 :close-on-click-modal="false"
			 :confirm-loading="isSubmitting" @confirm="handleKDNoSubmit"> <span style="display: block; margin-bottom: 20px"><strong>快递单号:</strong></span>
			<el-input clearable v-model="kuaiDiInfo.kdNo" placeholder="请输入快递单号"></el-input></lcsj-dialog>
		<!-- 审核确认框 -->
		<auditSubscription ref="auditSubscription"></auditSubscription>
		<!-- 批量审核弹出框 -->
		<batchAuditDialog ref="batchAuditDialog"></batchAuditDialog>
		<!-- 支付申购单 -->
		<paySubscription ref="paySubscription"></paySubscription>
	</div>
</template>

<script>
import { GetStoreSubscriptionPageList, AuditStoreSubscription, KuaiDiStoreSubScription } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from "@/views/product/subscription/detail.vue";
import purchaseConfirm from "@/views/product/subscription/purchaseConfirm.vue";
import auditSubscription from "@/views/product/subscription/auditSubscription.vue";
import batchAuditDialog from "@/views/product/subscription/batchAuditDialog.vue";
import paySubscription from "@/views/product/subscription/paySubscription.vue";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "申购单管理"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				state: 0,
				code: "",
				startTime: null,
				endTime: null,
				isPay: null
			},
			columnsData: [],
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "申购时间",
					width: "170",
					align: "center",
				},
				{
					prop: "creator",
					label: "申购人",
					width: "120",
					align: "center",
				},
				{
					prop: "storeName",
					label: "申购门店",
					width: "120",
					align: "center",
				},
				{
					slot: "stateStr",
					label: "申购状态",
					width: "120",
					align: "center",
				},
				{
					slot: "code",
					label: "申购单号",
					isKeep: true,
					minWidth: "170",
					align: "center"
				},
				{
					prop: "goodsTypeCount",
					label: "类型数量",
					width: "120",
					align: "center"
				},
				{
					prop: "goodsCount",
					label: "商品总数量",
					width: "120",
					align: "center"
				},
				{
					prop: "kdNo",
					label: "快递单号",
					width: "180",
					align: "center"
				},
				{
					prop: "purchaseUserName",
					label: "采购人",
					width: "120",
					align: "center"
				},
				{
					prop: "purchaseDate",
					label: "采购确认时间",
					width: "180",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "审核人",
					width: "120",
					align: "center"
				},
				{
					prop: "confirmDate",
					label: "审核时间",
					width: "180",
					align: "center"
				},
				{
					prop: "payUserName",
					label: "支付人",
					width: "120",
					align: "center"
				},
				{
					prop: "payDate",
					label: "支付时间",
					width: "180",
					align: "center"
				},
				{
					prop: "receiveUserName",
					label: "接收人",
					width: "120",
					align: "center"
				},
				{
					prop: "receiveDate",
					label: "接收时间",
					width: "180",
					align: "center"
				},
				{
					prop: "remark",
					label: "备注",
					width: "220",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "220",
					align: "center",
					fixed: "right"
				}
			],
			storeList: [],
			stateList: [],
			dateRange: [],
			selectedRows: [],
			btnPermission: {
				purchaseConfirm: false,
				audit: false,
				pay: false,
				kuaidi: false
			},
			kuaiDiInfo: {
				keyId: "",
				kdNo: ""
			},
			kuaidiVisible: false,
			auditResultInfo: {
				keyId: "",
				isPass: true,
				reason: ""
			},
			auditVisible: false
		};
	},
	// 注册组件
	components: {
		detail,
		purchaseConfirm,
		auditSubscription,
		batchAuditDialog,
		paySubscription
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();
		this.getListData();

		this.btnPermission.purchaseConfirm = this.$checkBtnPermission("/storeSubscription/index", "confirm");
		this.btnPermission.audit = this.$checkBtnPermission("/storeSubscription/index", "audit");
		this.btnPermission.pay = this.$checkBtnPermission("/storeSubscription/index", "pay");
		this.btnPermission.kuaidi = this.$checkBtnPermission("/storeSubscription/index", "kuaidi");
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreSubscriptionPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange() {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "StoreSubscriptionState"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.stateList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 门店选择事件
		handleStoreChange(val) {
			this.formInline.storeKeyId = val;
			this.search();
		},
		// 详情点击事件
		handleDetailClick(row) {
			this.$refs.detail.showDetail(row.keyId, 2);
		},
		// 勾选变化（不跨页，翻页/搜索后由表格重新触发）
		handleSelectionChange(rows) {
			this.selectedRows = rows || [];
		},
		// 批量审核点击事件
		handleBatchAuditClick() {
			if (this.selectedRows.length == 0) {
				this.$message({
					type: "warning",
					message: "请勾选要审核的申购单"
				});
				return;
			}
			const invalidRow = this.selectedRows.find((row) => row.state != 3);
			if (invalidRow) {
				this.$message({
					type: "warning",
					message: `申购单【${invalidRow.code}】不是【待审核】状态，请取消勾选后重试`
				});
				return;
			}
			this.$refs.batchAuditDialog.showBatchAudit(this.selectedRows.map((row) => row.keyId));
		},
		// 采购确认点击事件
		handlePurchaseConfirmClick(row) {
			this.$refs.purchaseConfirm.showPurchaseConfirmDetail(row.keyId);
		},
		// 审核点击事件
		handleAuditClick(row) {
			this.auditResultInfo = {
				keyId: row.keyId,
				isPass: true,
				reason: ""
			};
			this.auditVisible = true;
		},
		// 提交审核
		handleAuditSubmit() {
			if (!this.auditResultInfo.isPass) {
				if (!this.auditResultInfo.reason) {
					this.$message({
						type: "warning",
						message: "请输入驳回原因"
					});
					return;
				}
				AuditStoreSubscription(this.auditResultInfo)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "审核成功"
							});
							this.auditVisible = false;
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.auditVisible = false;
				// 审核通过
				this.$refs.auditSubscription.showAuditSubscriptionDetail(this.auditResultInfo.keyId);
			}
		},
		// 支付点击事件
		handlePayClick(row) {
			this.$refs.paySubscription.showPaySubscriptionDetail(row.keyId);
		},
		// 发货点击事件
		handleKuaidiClick(row) {
			this.kuaiDiInfo = {
				keyId: row.keyId,
				kdNo: ""
			};
			this.kuaidiVisible = true;
		},
		// 提交快递单号
		handleKDNoSubmit() {
			if (!this.kuaiDiInfo.kdNo) {
				this.$message({
					type: "warning",
					message: "请输入快递单号"
				});
				return;
			}
			this.$confirm("确认提交快递单号吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				KuaiDiStoreSubScription({
					keyIds: [this.kuaiDiInfo.keyId],
					kdNo: this.kuaiDiInfo.kdNo
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "提交成功"
							});
							this.kuaidiVisible = false;
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		}
	}
};
</script>

<style scoped>/* 行内操作文字链（由表格操作列改造脚本注入） */
.lcsj-row-actions {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	white-space: nowrap;
}

.lcsj-row-actions__link {
	color: var(--app-primary-text);
	cursor: pointer;
	font-size: var(--app-font-base);
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
	line-height: 1.6;
}

.lcsj-row-actions__link:hover {
	text-decoration: underline;
}

.lcsj-row-actions__link--danger {
	color: var(--app-danger-text);
}
</style>
